export const filmContent = {
    es: {
        eyebrow: 'PELÍCULAS Y SERIES',
        title: 'Streaming ilimitado de las últimas películas, series y canales en directo.',
        filmsLabel: 'Películas',
        seriesLabel: 'Series',
    },
};
